import { render, staticRenderFns } from "./SamButton.vue?vue&type=template&id=183d3e5b&scoped=true&"
import script from "./SamButton.vue?vue&type=script&lang=js&"
export * from "./SamButton.vue?vue&type=script&lang=js&"
import style0 from "./SamButton.vue?vue&type=style&index=0&id=183d3e5b&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "183d3e5b",
  null
  
)

export default component.exports